import { CSSProperties, FC, PropsWithChildren, ReactNode } from "react";
import { Stack as MantineStack, StackProps as MantineStackProps } from "@mantine/core";
import { classNames } from "@/utils/Classnames";

export interface StackProps extends MantineStackProps {
  className?: string;
  children?: ReactNode;
  grow?: boolean;
}

const Stack: FC<PropsWithChildren<StackProps>> = (props) => {
  const { className, children, grow } = props;
  const style = {
    "--stack-grow": grow ? 1 : "",
  } as CSSProperties;

  return (
    <MantineStack className={classNames(className ? className : "")} style={style} {...props}>
      {children}
    </MantineStack>
  );
};

export default Stack;
